import { createBrowserHistory } from "history";
import React, { useEffect } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Provider } from "react-redux";
import { Route,  BrowserRouter as Router, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import "./assets/styles/main.scss";
// import "./assets/styles/react-toastify.css";
import NotFound from "./layouts/components/NotFound";
import configureStore from "./redux/store/store";
import { renderAdminPanel, renderSimplePanel } from "./router";
import "./services/firebase";
import { getFirebaseToken } from "./services/firebase";
require("dotenv").config();
const App = (props) => {
  const hist = createBrowserHistory();
  let configStore = configureStore();
  const store = configStore.store;
  const persist = configStore.persistor;
  const FCMIDGet = window.location.fcm;
  const [isTokenFound, setTokenFound] = React.useState(false);
  useEffect(() => {
    getFirebaseToken(setTokenFound);
    if (FCMIDGet !== undefined) {
      console.log("fcm id get", FCMIDGet);
      localStorage.setItem("FCMID", FCMIDGet);
    } else {
      localStorage.setItem("FCMID", null);
    }
  }, []);
  return (
    <Provider store={store}>
      <PersistGate persistor={persist} loading={<p>Loading!!!</p>}>
        <Router history={hist}>
          <Switch>
            <Route path="/panel/:path?" exact>
              {renderAdminPanel(hist)}
            </Route>
            <Route path="/:path?" exact>
              {renderSimplePanel(hist)}
            </Route>
            <Route render={() => <NotFound />} exact path="/*" />
          </Switch>
        </Router>
        <ToastContainer />
      </PersistGate>
    </Provider>
  );
};

export default App;
